/**
 * Klucz słownikowy dla wartości pochodzących z bazy danych.
 *
 * Wartości takie jak opisy ról (`access.group_roles.description`, `access.role.description`)
 * czy tytuły zgłoszeń są w bazie trzymane po polsku — nie da się ich objąć zwykłymi
 * kluczami i18n, bo tekst powstaje poza frontem. Zamiast tego liczymy **stabilny klucz
 * z samej treści zdania**: to samo zdanie zawsze daje ten sam klucz, więc jedno wpisanie
 * tłumaczenia obsługuje każde miejsce, w którym to zdanie się pojawi.
 *
 * Zasady (muszą być identyczne w każdym generatorze słownika):
 *  1. przycięcie białych znaków i zamiana na małe litery,
 *  2. `ł` → `l` (nie rozkłada się przez NFD, więc trzeba osobno),
 *  3. usunięcie znaków diakrytycznych (NFD + odrzucenie znaków łączących),
 *  4. każdy ciąg znaków spoza `[a-z0-9]` → pojedynczy `-`,
 *  5. obcięcie `-` z początku i końca.
 *
 * Przykład: „Bieżące pojazdy, archiwum, VMS” → `biezace-pojazdy-archiwum-vms`.
 *
 * @param {string|null|undefined} text Tekst źródłowy (zwykle polski, z bazy).
 * @returns {string} Klucz bez prefiksu przestrzeni nazw (`db.`) — pusty, gdy nie da się go wyliczyć.
 */
export function dbKey(text) {
  if (text == null) {
    return "";
  }

  return String(text)
    .trim()
    .toLowerCase()
    .replace(/ł/g, "l")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export default dbKey;
